<template>
  <div class="about-page">
    <div class="content" v-html="detail"></div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      detail: ""
    };
  },
  methods: {
    getDetail() {
      this.$http.get("/api/app/config/about_us").then(res => {
        this.detail = res.about_us;
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.about-page {
  width: 100%;
  overflow: hidden;
  .content {
    /deep/ img {
      width: 100%;
    }
  }
}
</style>
